import React from 'react';
import s from './FeatureSection.scss';
import { Box } from '@wix/design-system';
import { FeatureSectionHeader, FeatureSectionContent, } from './components';
import { Hoverable, } from '../../../Hoverable';
import { useCollapse } from '../../../Collapse';
export const FeatureSectionContext = React.createContext({
    isOpen: false,
    toggleCollapse: () => { },
    isHovering: false,
    onMouseEnter: () => { },
    onMouseLeave: () => { },
});
export const FeatureSection = ({ children, dataHook, isOpen: isOpenDefault = false, }) => {
    const { isOpen, toggleCollapse } = useCollapse({ isOpen: isOpenDefault });
    const [isHovering, setIsHovering] = React.useState(false);
    const onMouseEnter = () => setIsHovering(true);
    const onMouseLeave = () => setIsHovering(false);
    const contextValues = {
        isOpen,
        toggleCollapse,
        isHovering,
        onMouseEnter,
        onMouseLeave,
    };
    return (React.createElement(FeatureSectionContext.Provider, { value: contextValues },
        React.createElement(Box, { className: s.sectionWrapper, dataHook: dataHook, direction: "vertical" }, children)));
};
FeatureSection.Header = FeatureSectionHeader;
FeatureSection.Features = FeatureSectionContent;
FeatureSection.Hoverable = Hoverable(FeatureSectionContext);
//# sourceMappingURL=FeatureSection.js.map